import React, { Component } from 'react'
import './Stores.css'
import Pagination from '../Common/Pagination'
import t from '../Language/language'
import * as languageSettings from '../Language/languageSettings'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import StoreMerge from './StoreMerge'
import { Modal } from 'react-bootstrap'
import * as storesFunctions from '../../actions/stores'
import * as modalAction from '../../actions/modalAction'
import ModalContainer from '../../containers/ModalContainer'
import AuthenticationService from '../Security/AuthenticationService'
import { Config } from '../../Config'
import downArrow from '../../images/down-arrow.png'
import Online from '../../images/connection_online.png'
import Offline from '../../images/connection_offline.png'
import Api from '../../Api'
import CommonLoader from '../Alerts/CommonLoader'
import { CommonConstants } from '../../Constants'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import NavigationService from '../Common/NavigationServices'
import CommonSearch from '../Common/Search'
import CommonStoreMethods from './CommonStoreMethod'
// StoreDetails (Admin) - Component.
class StoreDetail extends Component {
  constructor (props) {
    super(props)
    this.state = {
      language: languageSettings.getCurrentLanguage(),
      showStores: this.props.showStores,
      stores: {},
      Ascending: false,
      criteria: null,
      pageSize: 10,
      offset: 0,
      data: [],
      hasMore: true,
      storesListArray: [],
      isShowAll: false,
      show: false,
      pageCounter: 0,
      showCommonLoader: false,
      bulkInitLoading: false,
      deviceSelectZero: false,
      deviceSelectMTTwenty: false,
      devicesWereSentUpgrades: false,
      renderBulkDevices: false,
      renderBulkDevicesData: [],
      storeDevices: [],
      infiniteScrollPageSize: Config.infiniteScrollPageSize,
      storeUidArray: [],
      progress: '',
      forcePage: null,
      searchOptions: [
        { value: 'Brand_Name', name: t[languageSettings.getCurrentLanguage()].SearchBrand },
        { value: 'Store_Number', name: t[languageSettings.getCurrentLanguage()].SearchStore },
        { value: 'Store_Name', name: t[languageSettings.getCurrentLanguage()].SearchStoreName },
        { value: 'Device_SerialNumber', name: t[languageSettings.getCurrentLanguage()].SearchSerial },
        { value: 'Device_MainVersion', name: t[languageSettings.getCurrentLanguage()].SearchSystemVersion }
      ]
    }
    this.CommonStoreMethods = new CommonStoreMethods()
    this.navigate = new NavigationService()
    this.api = new Api()
    this.PageSizeValueDropdown = this.PageSizeValueDropdown.bind(this)
    this.PageClicked = this.PageClicked.bind(this)
    this.onSelectAlert = this.onSelectAlert.bind(this)
    this.search = this.search.bind(this)
    this.routeToViewDetail = this.routeToViewDetail.bind(this)
    this.authService = new AuthenticationService(Config.authBaseUrl)
    this.state.url = this.authService.getColdFusionAppUrl(this.authService.isAdmin())
    this.state.token = this.authService.getToken()
    this.checkRegisteredSystem = this.checkRegisteredSystem.bind(this)
  }

  // Using React lifecycle method and set the state value
  componentWillMount () {
    // Intializing default sort
    this.props.sortStores({ 'sortBy': 'Company_Name', 'sortType': 'ASC' })
    this.props.setStoresSearchParams({ 'filter': null, 'criteria': null })
    if (this.props.stores.adminStoreDetails.storeList.length >= this.state.infiniteScrollPageSize) {
      // Making an infinity scrolling active after popup close.
      this.setState({ isShowAll: true })
    }
  }
  // Handle on change event
  handleInputChange (e) {
    let cloneofStoreUIdArray = this.state.storeUidArray
    var index = cloneofStoreUIdArray.indexOf(e.target.value)
    if (index !== -1) {
      cloneofStoreUIdArray.splice(index, 1)
    } else {
      cloneofStoreUIdArray.push(e.target.value)
    }
    this.setState({
      storeUidArray: cloneofStoreUIdArray
    })
  }
  // Admin bulk action function for upgrade Zoom devices
  handleBulkAction (e) {
    this.setState({
      show: true
    })
  }

  // cancle the Zoom devices bulk upgrade
  cancelBulkPopHide (e) {
    this.setState({
      show: false
    })
  }
  // to handel Submit funtion for  Zoom devices bulk upgrade
  bulkSubmit (e) {
  // set the redirect URL and state
    const url = Config.apiBaseUrl + CommonConstants.apiUrls.getStoreDevices
    this.setState({
      show: false,
      showCommonLoader: true,
      bulkInitLoading: true,
      showStores: false
    })
    // check the storeUID
    if (this.state.storeUidArray.length === 0) {
      this.setState({
        show: false,
        showCommonLoader: false,
        bulkInitLoading: false,
        showStores: false,
        deviceSelectZero: true
      })
    } else if (this.state.storeUidArray.length >= 21) {
      this.setState({
        show: false,
        showCommonLoader: false,
        bulkInitLoading: false,
        showStores: false,
        deviceSelectZero: false,
        deviceSelectMTTwenty: true
      })
    } else {
      let submitData = {}
      submitData.suid = this.state.storeUidArray.toString() // ['AD688A2718E6454990FD77DBACE5E742','369544A9B4DE40A79401C9911C596DFF'] //Test Values
      let data = submitData
      // API call for  Zoom devices bulk upgrade
      this.api.postData(url, data, result => {
        // Check the result - whether zoom devices upgrade or not
        if (result.status) {
          if (result.data.length !== 0) {
            let iter = 0 // Check to see if any devices have logs of them already being told to upgrade. Only for CU50 for now.
            let devicesWereSentUpgrades = false
            for (iter = 0; iter < result.data.length; iter++) {
              if (result.data[iter].DeviceUpgrade_CU_Version_New === CommonConstants.currentCU50Version) {
                devicesWereSentUpgrades = true
              }
            }
            // if result is true
            if (!devicesWereSentUpgrades) {
              let mapData = result.data
              this.setState({
                showCommonLoader: false,
                bulkInitLoading: false,
                showStores: false,
                deviceSelectZero: false,
                deviceSelectMTTwenty: false,
                devicesWereSentUpgrades: false,
                renderBulkDevices: true,
                renderBulkDevicesData: mapData
              })
              // create logs for zoom device upgrade
              const urlUpgradeLog = Config.apiBaseUrl + CommonConstants.apiUrls.updateUpgradeLog

              let currentComponent = this
              mapData.map(function (upgradeData, index) {
                let d = upgradeData
                let api = new Api()
                api.postData(urlUpgradeLog, d, result => {
                  let objIndex = mapData.findIndex(obj => obj.Device_UID === result.data.Device_UID)
                  let objectReturn = mapData[objIndex]
                  objectReturn.progressType = result.status ? 'Success' : 'Failed'
                  mapData[objIndex] = objectReturn
                  currentComponent.setState({
                    renderBulkDevicesData: mapData,
                    progress: 'response'
                  })
                })
              })
            } else { // If API call returns false capture the errors and set the state.
              this.setState({
                show: false,
                showCommonLoader: false,
                bulkInitLoading: false,
                showStores: false,
                deviceSelectZero: false,
                deviceSelectMTTwenty: false,
                devicesWereSentUpgrades: true
              })
            }
          }
        } else {
          // If API call returns false capture the errors.
          console.log('errors errors')
        }
      })
    }
  }

  // go to store list page
  renderBack (e) {
    let url = '/admin/settings/stores'
    window.location.href = url
  }
  // set the pathname in router history
  routeToViewDetail () {
    this.props.history.push({ pathname: '/settings/stores/viewDetail' })
  }

  // Set pagination  for store list
  PageSizeValueDropdown (pageSize) {
    this.setState({ showCommonLoader: true, forcePage: null, offset: 0 })
    let totalRecords = this.props.stores.adminStoreDetails.pageDetails.RecordCount
    if (pageSize === totalRecords) {
      this.setState({ isShowAll: true })
      pageSize = this.state.infiniteScrollPageSize
    }
    let paginationParams = { pageSize: pageSize, pageNumber: 1 }
    this.setState({ pageSize })
    this.state.offset = Math.ceil((this.state.offset / 10) * pageSize)
    this.props.paginationAdminStores(paginationParams)
    this.props.adminStoresDetails(() => {
      this.setState({ showCommonLoader: false, forcePage: 0 })
    })
  }

  // pagination : PageClicked ( Redirect to selected page no)
  PageClicked (value) {
    if (this.state.criteria) {
      this.setState({ forcePage: 0 })
    }
    this.setState({ showCommonLoader: true })
    let paginationParams = { pageSize: this.state.pageSize, pageNumber: ((value / this.state.pageSize) + 1) }
    this.props.paginationAdminStores(paginationParams)
    this.props.adminStoresDetails(() => {
      this.setState({ showCommonLoader: false })
    })
    if (value === null) {
      return this.state.offset
    } else {
      this.state.offset = value
      return this.state.offset
    }
  }

  // Store View details
  viewDetails (data) {
    this.props.initStoreDetail(data.Store_UID, true)
  }

  // create alett for select menu
  onSelectAlert (eventKey) {
    window.alert(`Alert from menu item.\neventKey: ${eventKey}`)
  }

  // Store list page sech function
  search (selectedFilter, criteria) {
    this.setState({ showCommonLoader: true, forcePage: null, offset: 0, criteria: criteria })
    if (criteria) {
      let pageSize = this.state.pageSize
      this.props.setStoresSearchParams({ 'filter': selectedFilter, 'criteria': criteria })
      if (this.state.isShowAll) {
        pageSize = this.state.infiniteScrollPageSize
      }
      let paginationParams = {
        pageSize: pageSize,
        pageNumber: 1
      }
      this.props.paginationAdminStores(paginationParams)
      this.props.adminStoresDetails(() => {
        this.setState({ showCommonLoader: false, forcePage: 0 })
      })
    } else {
      window.location.href = '/admin/settings/stores'
    }
  }
  // On keypress while we using enter button
  onEnterPress (e) {
    if (e.key === 'Enter') {
      if (this.state.criteria === '') {
        window.location.href = '/settings/stores'
      }
      this.search()
    }
  }
  // On keypress while we using enter button
  handleSearchChange (e) {
    this.props.setStoresSearchParams({ 'filter': e.target.value, 'criteria': null })
  }

  // handle serch Criteria
  handleCriteria (e) {
    this.setState({ [e.target.name]: e.target.value })
  }
  // Show all stores in one page
  render () {
    return (
      <div>
        {this.defaultRender()}
      </div>
    )
  }

  // Displaying Default storelist
  defaultRender () {
    const { language } = this.state
    let sortParams = this.props.storesDetails.sortParams ? this.props.storesDetails.sortParams : { 'sortBy': 'Company_Name', 'sortType': 'ASC' }
    let recordCount = (this.props.storesDetails.adminStoreDetails.pageDetails !== undefined) ? this.props.storesDetails.adminStoreDetails.pageDetails.RecordCount : 10
    let pageCount = (this.props.storesDetails.adminStoreDetails.pageDetails !== undefined) ? this.props.storesDetails.adminStoreDetails.pageDetails.TotalPages : 10
    return (
      <div>
        {/* Set the Loader function  */}
        <CommonLoader showLoader={this.state.showCommonLoader} message={'Loading...'} />
        <div className={this.state.showCommonLoader ? 'hide' : 'show'}>
          <section className={'stores ' + (this.state.showStores ? 'show' : 'hidden')}>
            <div className='settings forms'>
              <div className='settings_search clear storeHeight storesHeaderSection'>
                <div className='storesHeaderSections'><h3 className='clear pull-left'>{t[language].homepageStores}
                  <div className='bulkAction-container'>
                    <span className='bulkAction'>Bulk Actions <img src={downArrow} className='downArrow' alt='down-Arrow' /></span>
                    <div className='child-actions'>
                      <span className='bulkAction' onClick={(e) => { this.handleBulkAction(e) }}>Upgrade ZOOM CU50(s)</span>
                    </div>
                  </div>
                </h3>
                </div>
                <div className='storesHeaderSections'>
                  <CommonSearch onSearch={this.search}
                    searchOptions={this.state.searchOptions} />
                </div>
              </div>
              <div className='settings_plug clear storeHeight' />
              <div className='settings_list'>
                <div className='storesTable ctable'>
                  {/* set/get sort order */}
                  <Table>
                    <Thead><Tr className='theader clear storesTableHeader'>
                      <Th />
                      <Th className={(sortParams.sortBy === 'Company_Name' && sortParams.sortType === 'ASC') ? 'actcold' : ((sortParams.sortBy === 'Company_Name' && sortParams.sortType === 'DESC') ? 'actcol' : '')}><a><span id='Company_Name' onClick={this.sortStores.bind(this)}>{t[language].companyname}</span></a></Th>
                      <Th className={(sortParams.sortBy === 'Brand_Name' && sortParams.sortType === 'ASC') ? 'actcold' : ((sortParams.sortBy === 'Brand_Name' && sortParams.sortType === 'DESC') ? 'actcol' : '')}><a><span id='Brand_Name' onClick={this.sortStores.bind(this)}>{t[language].brand}</span></a></Th>
                      <Th className={(sortParams.sortBy === 'Store_Number' && sortParams.sortType === 'ASC') ? 'actcold' : ((sortParams.sortBy === 'Store_Number' && sortParams.sortType === 'DESC') ? 'actcol' : '')}><a> <span id='Store_Number' onClick={this.sortStores.bind(this)}>{t[language].store} #</span></a></Th>
                      <Th className={(sortParams.sortBy === 'Store_Name' && sortParams.sortType === 'ASC') ? 'actcold' : ((sortParams.sortBy === 'Store_Name' && sortParams.sortType === 'DESC') ? 'actcol' : '')}><a><span id='Store_Name' onClick={this.sortStores.bind(this)}>{t[language].settingsStoresStoreName}</span></a></Th>
                      <Th className={(sortParams.sortBy === 'Store_AddressLine1' && sortParams.sortType === 'ASC') ? 'actcold' : ((sortParams.sortBy === 'Store_AddressLine1' && sortParams.sortType === 'DESC') ? 'actcol' : '')}><a> <span id='Store_AddressLine1' onClick={this.sortStores.bind(this)}>{t[language].StoreSettingsHeaderAddress}</span></a></Th>
                      <Th id='innertable1' className={(sortParams.sortBy === 'Device_SerialNumber' && sortParams.sortType === 'ASC') ? 'actcold' : ((sortParams.sortBy === 'Device_SerialNumber' && sortParams.sortType === 'DESC') ? 'actcol' : '')}><a> <span id='Device_SerialNumber' onClick={this.sortStores.bind(this)}>{t[language].Serial} #</span></a></Th>
                      <Th id='innertable1' className={(sortParams.sortBy === 'Device_MainVersion' && sortParams.sortType === 'ASC') ? 'actcold' : ((sortParams.sortBy === 'Device_MainVersion' && sortParams.sortType === 'DESC') ? 'actcol' : '')}><a> <span id='Device_MainVersion' onClick={this.sortStores.bind(this)}>Version</span></a></Th>
                      <Th id='innertable2' className={(sortParams.sortBy === 'Subscription_Name' && sortParams.sortType === 'ASC') ? 'actcold' : ((sortParams.sortBy === 'Subscription_Name' && sortParams.sortType === 'DESC') ? 'actcol' : '')}><a> <span id='Subscription_Name' onClick={this.sortStores.bind(this)}>{t[language].HelpSubscription}</span></a></Th>
                      <Th id='innertable2' className={(sortParams.sortBy === 'Device_IsActive' && sortParams.sortType === 'ASC') ? 'actcold' : ((sortParams.sortBy === 'Device_IsActive' && sortParams.sortType === 'DESC') ? 'actcol' : '')}><a> <span id='Device_IsActive' onClick={this.sortStores.bind(this)}>{t[language].storestatus}</span></a></Th>
                    </Tr>
                    </Thead>
                    <Tbody>
                      {!this.state.showCommonLoader ? this.renderStores() : '' }
                    </Tbody>
                  </Table>
                  {<Pagination
                    perPage={this.state.pageSize}
                    PageSizeValueChange={this.PageSizeValueDropdown}
                    offset={this.PageClicked}
                    recordCount={recordCount}
                    pageCount={pageCount}
                    offSetValue={this.state.offset}
                    forcePage={this.state.forcePage} />}
                </div>
              </div>
            </div>
            {/* Show modelcontainer and display the device details */}
            <ModalContainer onHide={this.smClose} routeToViewDetail={this.routeToViewDetail} history={this.props.history} />
            <StoreMerge onHide={this.smClose} />
            {this.renderModal()}
          </section>
          {/* Bulk button actions */}
          <section className={'stores ' + (this.state.bulkInitLoading ? 'show' : 'hidden')}>
            <div className='col1'>
              <div className='store-loading'>
                <h3 className='load_msg'>Please wait while your request is being processed...</h3>
                <div>
                  <CommonLoader showLoader={this.state.showCommonLoader} message={''} />
                </div>
                <p className='load_note'>Please Note: This may take a while to load depending on the amount of data being requested.</p>
              </div>
            </div>
          </section>
          <section className={'' + (this.state.deviceSelectZero ? 'show' : 'hidden')}>
            <div className='error no-device-error'>
              <p>The following errors occured during your request:</p>
              <ul>
                <li>You must select 1 or more devices to initiate upgrades.</li>
              </ul>
              <a onClick={(e) => { this.renderBack(e) }}>Go Back</a>
            </div>
          </section>
          <section className={'' + (this.state.deviceSelectMTTwenty ? 'show' : 'hidden')}>
            <div className='error no-device-error'>
              <p>Request Failed:</p>
              <ul>
                <li>Please be sure you selected between 1 and 20 CU50 devices with version numbers of 3.6 or greater.</li>
              </ul>
              <a onClick={(e) => { this.renderBack(e) }}>Go Back</a>
            </div>
          </section>
          <section className={'' + (this.state.devicesWereSentUpgrades ? 'show' : 'hidden')}>
            <div className='error no-device-error'>
              <p>Request Failed:</p>
              <ul>
                <li>Please do not select any devices you have already requested to upgrade.</li>
              </ul>
              <a onClick={(e) => { this.renderBack(e) }}>Go Back</a>
            </div>
          </section>
          <section className={'users listingAdmin deviceBulkListing ' + (this.state.renderBulkDevices ? 'show' : 'hidden')}>
            <div className={'settings forms ' + (!this.state.showCommonLoader ? '' : 'hidden')}>
              <div className='settings_plug clear'>
                <div className='settings_list'>
                  <div className='ctable'>
                    <h3>ZOOM System Upgrades</h3>
                    <p><strong>Please Note:</strong> The upgrade will start in approximately 5 minutes. Your ZOOM system will be unavailable for an additional 20 to 25 minutes while the upgrade is in progress.</p>
                    <Table>
                      <Thead>
                        <Tr className='theader clear'>
                          <Th>
                            <a>Brand Name</a>
                          </Th>
                          <Th>
                            <a>Store Number</a>
                          </Th>
                          <Th>
                            <a>System Type</a>
                          </Th>
                          <Th>
                            <a>Current CU Version</a>
                          </Th>
                          <Th>
                            <a>Current Settings Version</a>
                          </Th>
                          <Th>
                            <a>Upgrade CU Version</a>
                          </Th>
                          <Th>
                            <a>Upgrade Settings Version</a>
                          </Th>
                          <Th>
                            <a>Upgrade Status</a>
                          </Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {this.renderBulkActionDevices()}
                      </Tbody>
                    </Table>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    )
  }

  renderBulkActionDevices () {
    if (this.state.renderBulkDevicesData && this.state.renderBulkDevicesData.length > 0) {
      let progessStatus = 'Upgrading...'
      let devices = this.state.renderBulkDevicesData
      let p = this.state.progress
      let deviceRows = devices.map(function (device, index) {
        return (
          <Tr className='tdata clear'>
            <Td>{device.Brand_Name}</Td>
            <Td>{device.Store_Number}</Td>
            <Td>{device.Device_Name}</Td>
            <Td>{device.Device_MainVersion}</Td>
            <Td>{device.Device_SettingVersion}</Td>
            <Td>{Config.upgradableDeviceVersionTypes[Config.upgradableDeviceVersionTypes.length - 1]}</Td>
            <Td>{device.Upgrade_Settings_Version}</Td>
            <Td className={'success ' + (device.progressType === 'Success' ? 'show' : 'hidden')}>{device.progressType}</Td>
            <Td className={'failed ' + (device.progressType === 'Failed' ? 'show' : 'hidden')}>{device.progressType}</Td>
            <Td className={'yellow ' + (p === '' ? 'show' : 'hidden')}>{progessStatus}</Td>
          </Tr>
        )
      })
      return deviceRows
    } else {
      return (<div />)
    }
  }
  // displaying upgrade action popup
  renderModal () {
    // let Modal = ReactBootstrap.Modal
    return (
      <Modal show={this.state.show} dialogClassName='adminAccPopUp' onHide={this.handleClose} >
        <Modal.Body className='popUpbody'>
          <h5>Confirmation Required</h5>
          <div className='insideModal'>
            <p className='paraOne'>Are you sure you would like to upgrade the selected store(s)?</p>
            <p className='paraTwo'><span className='redText'><strong>WARNING</strong></span>:
              This action cannot be undone! Your ZOOM system will be offline during the upgrade process for approximately 20 to 25 Minutes.
              Please DO NOT initiate any upgrades to the same device until the action is complete, or else it WILL be damaged.
            </p>
          </div>
          <div className='buttons-pop-up'>
            <input type='button' onClick={(e) => { this.bulkSubmit(e) }} value='Confirm' />
            <input type='button' onClick={(e) => { this.cancelBulkPopHide(e) }} value='Cancel' />
          </div>
        </Modal.Body>
      </Modal>
    )
  }
  // replace HTTPS to HTTP
  renderHTTP (url) {
    return url.replace('https', 'http')
  }

  // get the devices status
  renderStatus (device) {
    const { language } = this.state
    if (device.Device_IsActive === 1) {
      return (<a style={{ 'textAlign': 'center', color: parseInt(device.Device_IsActive) === 1 ? 'red' : 'black' }} href={this.navigate.getMenu('connect', device.Device_UID)}>{parseInt(device.Device_IsActive) === 1 ? ((device.Device_Name ? device.Device_Name : ' ') + ' ' + t[language].settingsStoresOnline) : ((device.Device_Name ? device.Device_Name : ' ') + ' ' + t[language].settingsStoresOffline)}</a>)
    } else {
      return (<span style={{ 'textAlign': 'center', color: 'black' }}>{parseInt(device.Device_IsActive) === 1 ? ((device.Device_Name ? device.Device_Name : ' ') + ' ' + t[language].settingsStoresOnline) : ((device.Device_Name ? device.Device_Name : ' ') + ' ' + t[language].settingsStoresOffline)}</span>)
    }
  }

  // checkRegisteredSystem
  checkRegisteredSystem (device) {
    let event = this
    const { language } = this.state
    if ((device.Device_Name !== null && device.Device_Name !== undefined) && (device.Device_MainVersion !== null && device.Device_MainVersion !== undefined)) {
      return (
        <div id='innertable2'>
          <img src={Online} className={'cstat ' + (parseInt(device.Device_IsActive) === 1 ? '' : 'hidden')} alt='Device Online' />
          <img src={Offline} className={'cstat ' + (parseInt(device.Device_IsActive) === 0 || !device.Device_IsActive ? '' : 'hidden')} alt='Device Offline' />
          <span className='cstat deviceStatus'>
            {event.renderStatus(device)}
          </span>
        </div>
      )
    } else {
      return (<Td className='unavailable' id='innertable2'><span className='cstat deviceStatus'>{t[language].settingsStoresNotavailable}</span></Td>)
    }
  }
  // check device version
  checkVersionIsUpgradable (deviceMainVersion, deviceIsActive) {
    let upgradableVersionTypes = Config.upgradableDeviceVersionTypes
    let latestVersion = Config.upgradableDeviceVersionTypes[Config.upgradableDeviceVersionTypes.length - 1]
    let versionIsUpgradable = false
    if (deviceMainVersion !== null) {
      let versionType = ''
      let versionTypeArray = deviceMainVersion.trim().split('.')
      if (Number(versionTypeArray[0]) > 2) {
        versionType = `${versionTypeArray[0]}.${versionTypeArray[1]}`
      } else {
        versionType = deviceMainVersion.trim().substring(0, 3)
      }

      if (latestVersion !== deviceMainVersion && upgradableVersionTypes.indexOf(versionType) > -1 && deviceIsActive === 1) {
        versionIsUpgradable = true
      }
      // .map((item) => {
      //   if (item === versionType) {

      //   }
      // })
    }
    return versionIsUpgradable
  }

  renderText (text) {
    return this.CommonStoreMethods.renderText(text)
  }
  // Displaying the stores list
  renderStores () {
    const { language } = this.state
    let self = this
    let storeList = this.props.stores.adminStoreDetails.storeList
    if (storeList && storeList.length > 0) {
      let storeRows = storeList.map(function (store, index) {
        let versionIsUpgradable = false
        if (store.Device_Details[0].Device_MainVersion !== null) {
          let deviceMainVersion = store.Device_Details[0].Device_MainVersion
          let deviceIsActive = store.Device_Details[0].Device_IsActive
          versionIsUpgradable = self.checkVersionIsUpgradable(deviceMainVersion, deviceIsActive)
        }
        return (
          <Tr className='tdata clear' key={index}>
            <Td className='cdet store_checkbox'>
              <input type='checkbox' name='edit_selected' value={store.Store_UID} disabled={!versionIsUpgradable} onChange={(e) => { self.handleInputChange(e) }} />
            </Td>
            <Td className='tooltipText'>
              {self.renderText(store.Company_Name)}
              <br /><span className='edit_settings'><a className='opener view_details' onClick={self.viewDetails.bind(self, store)}>{t[language].settingsStoresViewDetails}</a></span></Td>
            <Td>{store.Brand_Name}</Td>
            <Td>{store.Store_Number}</Td>
            <Td>{store.Store_Name}</Td>
            <Td className='tooltipText'>
              {self.renderText(store.Store_AddressLine1)}
            </Td>
            <Td>{self.renderSerialNumber(store.Device_Details)}</Td>
            <Td>{self.renderDeviceVersion(store.Device_Details)}</Td>
            <Td>{self.renderSubscriptionName(store.Device_Details)}</Td>
            <Td>{self.renderDeviceStatus(store.Device_Details)}</Td>
          </Tr>
        )
      })
      return storeRows
    } else {
      // Displaying when no stroes are in stores list
      return (
        <Tr className='tdata clear'>
          <Td colSpan='8' className='settings_table_noStores'> <h3>{t[language].NoStoresFound}</h3> </Td>
        </Tr>
      )
    }
  }
  // renderSerialNumber from devices
  renderSerialNumber (devices) {
    let deviceRows = devices.map(function (device, index) {
      return (
        <div className='storesColumns' width='90'>{device.Device_SerialNumber}</div>
      )
    })
    return deviceRows
  }
  // renderDeviceVersion from devices
  renderDeviceVersion (devices) {
    let deviceRows = devices.map(function (device, index) {
      return (
        <div className='storesColumns' width='110'>{device.Device_MainVersion}</div>
      )
    })
    return deviceRows
  }
  // renderSubscriptionName from devices
  renderSubscriptionName (devices) {
    let deviceRows = devices.map(function (device, index) {
      let subscriptionName = typeof device.Subscription_Name === 'string' ? device.Subscription_Name.split(' ')[0] : ''
      return (
        <div className='storesColumns' width='110'>{subscriptionName}</div>
      )
    })
    return deviceRows
  }
  // renderDeviceStatus from devices
  renderDeviceStatus (devices) {
    let event = this
    let deviceRows = devices.map(function (device, index) {
      return (
        <div className='storesColumns' width='110'>{event.checkRegisteredSystem(device)}</div>
      )
    })
    return deviceRows
  }
  // displaying store sort order
  sortStores (e) {
    this.setState({ showCommonLoader: true })
    if (this.state.isShowAll) {
      let pageSize = this.state.infiniteScrollPageSize
      let paginationParams = {
        pageSize: pageSize,
        pageNumber: 1
      }
      this.props.paginationAdminStores(paginationParams)
    }
    let Ascending = !this.state.Ascending
    this.setState({ Ascending: Ascending })
    let sortBy = e.target.id
    let sortType = this.state.Ascending ? 'DESC' : 'ASC'
    let sortParams = { 'sortBy': sortBy, 'sortType': sortType }
    this.props.sortStores(sortParams)
    this.props.adminStoresDetails(() => {
      this.setState({ showCommonLoader: false })
    })
  }
}
// get the state from Redux action file
function mapStateToProps (state) {
  return {
    storesDetails: state.storeDetails,
    storeModelPopup: state.StorePopupDetails.storePopUpAdmin,
    storeModelPopupIsAdmin: state.StorePopupDetails.storePopUpDetailisAdmin
  }
}
// call Redux actions
function mapDispatchToProps (dispatch) {
  return bindActionCreators(
    {
      sortStores: storesFunctions.sortStores,
      setStoresSearchParams: storesFunctions.setStoresSearchParams,
      adminStoresDetails: storesFunctions.adminStoresDetails,
      paginationAdminStores: storesFunctions.paginationAdminStores,
      initStoreDetail: modalAction.initStoreDetail
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(StoreDetail)



// WEBPACK FOOTER //
// ./src/components/Stores/StoreDetailsAdmin.js